import { thailandArticlesCardData } from './thailand/thailand-articles-card-map';
import { cambodiaArticlesCardData } from './cambodia/cambodia-articles-card-map';
import { vietnamArticlesCardData } from './vietnam/vietnam-articles-card-map';

export interface ArticleData {
  articleLink: string;
  title: string;
  description: string;
  relatedArticlesSlugs?: string[];
  imageUrl: string;
  date: string;
  readTime: string;
  slug: string;
}

interface ArticlesData {
  [key: string]: ArticleData[];
}

export const articlesCardData: ArticlesData = {
  thailand: thailandArticlesCardData,
  vietnam: vietnamArticlesCardData,
  cambodia: cambodiaArticlesCardData,
};
